import { useState, useCallback, useEffect } from 'react'
import { HiMiniWallet } from 'react-icons/hi2'
import { salariesAndBenefitsTranslate, SalaryComparativeTranslate } from '../../i18n/translatedMessages'
import { FlagArgentina, FlagBrasil, FlagChile, FlagColombia, FlagMexico, FlagPeru, FlagUruguay, FlagUSA } from '../../Icons/Flags'
import { calcComparative } from '../../Components/SalaryBand/Utils/Calc'
import { CreatePositions } from '../../Components/Positions/CreatePositions'
import { populateTemplatePositions } from '../../libs/excelPositions'
import Masks from '../../Utils/masks'
import SalaryPositions from '../../API/Services/Salary/Positions'
import Loading from '../../Components/Loading/Loading'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { FormJobMatch } from '../../Components/Employee/Form/formJobMatch'

const flags = {
	1: { flag: <FlagChile width='28px' height='28px' />, currency: 'CLP' },
	2: { flag: <FlagArgentina width='28px' height='28px' />, currency: 'ARS' },
	3: { flag: <FlagPeru width='28px' height='28px' />, currency: 'PEN' },
	4: { flag: <FlagBrasil width='28px' height='28px' />, currency: 'BRL' },
	5: { flag: <FlagColombia width='28px' height='28px' />, currency: 'COP' },
	6: { flag: <FlagMexico width='28px' height='28px' />, currency: 'MXN' },
	8: { flag: <FlagUruguay width='28px' height='28px' />, currency: 'UYU' },
	9: { flag: <FlagUSA width='28px' height='28px' />, currency: 'USD' },
	10: { flag: <FlagUruguay width='28px' height='28px' />, currency: 'UYU' },
}
export function Positions() {
	const [loadingReport, setLoadingReport] = useState(false)
	const [show, setShow] = useState(false)
	const [positionsList, setPositionsList] = useState([])
	const [loading, setLoading] = useState(true)
	const [deletingPositionId, setDeletingPositionId] = useState(null)

	const [positionToEdit, setPositionToEdit] = useState(null)

	const [jobMatchOpen, setJobMatchOpen] = useState(false)
	const [selectedItem, setSelectedItem] = useState(null)
	const [itemData, setItemData] = useState(null)

	// const downloadReport = async id => {
	// 	let bringReport = null
	// 	try {
	// 		setLoadingReport(id)
	// 		const getData = await SalaryBand.getReportDataEmployee(id)
	// 		if (getData) {
	// 			bringReport = await SalaryBand.getReportEmployee(getData)
	// 		}
	// 	} catch (error) {
	// 	} finally {
	// 		setLoadingReport(null)
	// 		if (bringReport) {
	// 			return window.open(
	// 				`https://smtm.co/v1/reports/api_recover?authorization=19c073e1768a3cbf6e9d76390e640f3b&email=${bringReport.report_sent.report_info.params.email}&code=${bringReport.report_sent.report_info.params.code}`,
	// 				'_blank',
	// 				'noopener,noreferrer'
	// 			)
	// 		}
	// 	}
	// }

	const loadData = useCallback(async () => {
		try {
			setLoading(true)
			const data = await SalaryPositions.getPositions(JSON.parse(localStorage.getItem('user')).id)
			setPositionsList(data.toSorted((a, b) => a.job_name.localeCompare(b.job_name, 'en', { sensitivity: 'base' })))
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	const addPosition = newPosition => {
		const countryData = flags[newPosition.country] || {}

		setPositionsList(prevList => {
			const exists = prevList.find(p => p.id === newPosition.id)

			if (exists) {
				return prevList.map(p =>
					p.id === newPosition.id
						? {
								...newPosition,
								salaryInfo: {
									typeCurrency: countryData.currency || '$',
									salary: newPosition.salary || '0',
								},
						  }
						: p
				)
			} else {
				return [
					...prevList,
					{
						...newPosition,
						salaryInfo: {
							typeCurrency: countryData.currency || '$',
							salary: newPosition.salary || '0',
						},
					},
				]
			}
		})

		loadData()
	}

	const language = 'es'

	const createTemplate = async () => {
		try {
			setLoadingReport(true)
			const userId = JSON.parse(localStorage.getItem('user')).id
			const data = await SalaryPositions.dataToExcelPosition(userId)
			const sortedData = data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
			populateTemplatePositions(sortedData, language)
		} catch {
		} finally {
			setLoadingReport(null)
		}
	}

	const handleDeletePosition = async (id, email) => {
		try {
			setDeletingPositionId(id)
			await SalaryPositions.deletePosition(id, email)
			const updatedList = positionsList.filter(position => position.id !== id)
			setPositionsList(updatedList)
		} catch (error) {
			console.error('Erro ao excluir a posição:', error)
		} finally {
			setDeletingPositionId(null)
		}
	}

	const handleEditPosition = position => {
		setPositionToEdit(position)
		setShow(true)
	}

	const handleCreatePosition = () => {
		setPositionToEdit(null)
		setShow(true)
	}

	const handleJobMatchClick = item => {
		setSelectedItem(item)
		setJobMatchOpen(true)
	}

	const handleChange = event => {
		loadData()
	}

	return (
		<>
			<CreatePositions
				show={show}
				setShow={setShow}
				addPosition={addPosition}
				positionToEdit={positionToEdit}
				title={positionToEdit ? 'Editar Posición' : 'Crear Posición'}
			/>
			<FormJobMatch handleChange={handleChange} user={selectedItem} isOpen={jobMatchOpen} onClose={() => setJobMatchOpen(false)} byPosition={true} />
			<div className='tw-h-full tw-w-full tw-pr-10 tw-z-0'>
				<div className='tw-flex tw-justify-between tw-items-start'>
					<div className='tw-w-10/12'>
						<h3 className='tw-flex tw-items-center tw-gap-2 tw-mb-4 tw-font-bold'>
							{/* <HiMiniWallet className='tw-text-blue-400' /> */}
							Salarios por Posición
						</h3>
						<div className='tw-text-base tw-mb-4'>{SalaryComparativeTranslate.subtitle}</div>
					</div>
					<div className='tw-flex tw-gap-2 tw-items-center'>
						<button
							className='tw-bg-purple-500 hover:tw-bg-purple-700 tw-text-white tw-p-2 tw-px-4 tw-rounded-md border-0 tw-whitespace-nowrap'
							onClick={handleCreatePosition}
						>
							Crear Posición
						</button>
						{loadingReport ? (
							<div className='tw-bg-gray-600 tw-text-white tw-p-2 tw-px-4 tw-rounded-md border-0 tw-flex tw-items-center   tw-justify-center tw-top-0 tw-left-0'>
								<div className='spinner-border tw-h-5 tw-w-5' role='status'>
									<span className='sr-only'>Loading...</span>
								</div>
							</div>
						) : (
							<button
								className='tw-bg-gray-600 tw-whitespace-nowrap hover:tw-bg-gray-800 tw-text-white tw-p-2 tw-px-4 tw-rounded-md border-0'
								onClick={createTemplate}
							>
								Descargar Listado
							</button>
						)}
					</div>
				</div>

				{loading ? (
					<Loading />
				) : (
					<div className='tw-w-full tw-overflow-x-auto tw-rounded-md border'>
						<div className='tw-flex tw-min-w-[600px] tw-bg-gray-100 tw-px-4 tw-py-2'>
							<div className='tw-font-bold tw-w-3/12 tw-ml-4 tw-flex tw-justify-start'>Posición</div>
							<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleCoin}</div>
							<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleSalary}</div>
							<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>Mercado</div>
							<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>Comparativo</div>
							<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Ações</div>
						</div>

						<div className='tw-max-h-[calc(100vh_-_400px)] tw-overflow-y-auto'>
							{positionsList?.length > 0 ? (
								positionsList.map(position => (
									<div key={position.id} className='tw-flex tw-min-w-[600px] tw-h-[100px] tw-border-b tw-items-center hover:tw-bg-gray-50'>
										<div className='tw-w-3/12 tw-ml-4 tw-flex tw-items-center tw-gap-4'>
											<div
												title={position.job_name}
												className='tw-min-w-[60px] tw-min-h-[60px] border tw-rounded-full tw-flex tw-items-center tw-justify-center tw-relative tw-text-purple-400 tw-text-2xl'
											>
												<span>{position.job_name?.charAt(0)}</span>
												<div
													title={position.country}
													className='tw-absolute tw-bg-purple-500 tw-w-6 tw-h-6 tw-bottom-[-5px] tw-right-[-5px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-text-xs'
												>
													{flags[position.country]?.flag ?? '-'}
												</div>
											</div>
											<h4 className='tw-text-base tw-font-bold tw-m-0 tw-p-0'>{position.job_name}</h4>
										</div>

										<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
											<h4 className='tw-text-base tw-p-0'>( {position.salaryInfo.typeCurrency} )</h4>
										</div>

										<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
											{position.salary === 0 || position.salary === null ? (
												<span className='tw-bg-gray-200 tw-px-3 tw-rounded-full tw-text-gray-500'>
													{salariesAndBenefitsTranslate.salaryNotInfomed}
												</span>
											) : (
												Masks.setDots(position.salary, false)
											)}
										</div>

										<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
											{Masks.setDots(position.smtm_market_salary, false) || (
												<span
													className='tw-bg-green-500 tw-px-3 tw-rounded-full tw-text-white tw-cursor-pointer'
													onClick={() => handleJobMatchClick(position)}
												>
													Seleccionar
												</span>
											)}
										</div>

										<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
											{calcComparative(Number(position.smtm_market_salary), position.salary)}
										</div>

										<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-start tw-gap-3'>
											<FaEdit
												className='tw-text-blue-500 tw-h-4 tw-w-4 tw-cursor-pointer hover:tw-text-blue-700'
												title='Editar'
												onClick={() => handleEditPosition(position)}
											/>
											{deletingPositionId === position.id ? (
												<div className=' tw-text-purple-500 tw-p-2 tw-px-4 tw-rounded-md border-0 tw-flex tw-items-center tw-justify-center tw-top-0 tw-left-0'>
													<div className='spinner-border tw-h-4 tw-w-4' role='status'>
														<span className='sr-only'>Loading...</span>
													</div>
												</div>
											) : (
												<FaTrashAlt
													className='tw-text-error-500 tw-cursor-pointer hover:tw-text-error-700 tw-h-4 tw-w-4'
													title='Excluir'
													onClick={() => handleDeletePosition(position.id, position.mydna_email_position)}
												/>
											)}
										</div>
									</div>
								))
							) : (
								<div className='tw-w-full tw-h-[100px] tw-flex tw-items-center tw-justify-center tw-text-gray-500'>No Data</div>
							)}
						</div>
					</div>
				)}
			</div>
		</>
	)
}
